/* No tracking, dependencies or separate cart: all purchases use the native form. */
(() => {
  const define = (name, component) => { if (!customElements.get(name)) customElements.define(name, component); };
  define('monela-finder', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelector('form')?.addEventListener('change', () => this.filter(), options);
      this.querySelector('[data-finder-reset]')?.addEventListener('click', () => {
        this.querySelector('form').reset(); this.filter();
        this.querySelector('input').focus();
      }, options);
      this.filter();
    }
    filter() {
      const selected = (key) => this.querySelector(`[data-filter="${key}"]:checked`)?.value || 'all';
      let count = 0;
      this.querySelectorAll('[data-finder-card]').forEach(card => {
        card.hidden = ['family','texture'].some(key => selected(key) !== 'all' && card.dataset[key] !== selected(key));
        if (!card.hidden) count++;
      });
      this.querySelector('[data-finder-status]').textContent = `${count} texture${count === 1 ? '' : 's'} à découvrir`;
      this.querySelector('[data-finder-empty]').hidden = count > 0;
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
  define('monela-compare', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      const range = this.querySelector('input[type=range]');
      if (!range) return;
      const update = () => {
        const value = Math.max(0, Math.min(100, Number(range.value)));
        this.style.setProperty('--mp-position', `${value}%`);
        range.setAttribute('aria-valuetext', `${value} % de l’image avant`);
      };
      range.addEventListener('input', update, { signal: this.controller.signal }); update();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
  define('monela-dialog', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const dialog = this.querySelector('dialog'), opener = this.querySelector('[data-dialog-open]');
      if (!dialog || !opener) return;
      opener.addEventListener('click', () => dialog.showModal(), options);
      this.querySelector('[data-dialog-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => { if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      } }, options);
      dialog.addEventListener('close', () => opener.focus(), options);
    }
    disconnectedCallback() { this.querySelector('dialog[open]')?.close(); this.controller?.abort(); }
  });
  define('monela-purchase', class extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info');
      this.sectionId = this.dataset.section;
      if (!this.info || this.closest('quick-add-modal')) return;
      this.controller?.abort(); this.controller = new AbortController();
      this.querySelector('[data-purchase-submit]').addEventListener('click', () => {
        const button = this.sourceButton;
        const form = this.info.querySelector(`#product-form-${CSS.escape(this.sectionId)}`);
        if (!form || !button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
        // Return to the real form so validation, server errors and confirmation
        // are visible, including when the cart drawer is disabled.
        form.scrollIntoView({ block: 'center', behavior: 'auto' });
        button.focus({ preventScroll: true });
        form.requestSubmit(button);
      }, { signal: this.controller.signal });
      this.mutations = new MutationObserver(() => this.sync());
      this.mutations.observe(this.info, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled','aria-disabled'] });
      this.resize = () => this.visibility();
      window.addEventListener('resize', this.resize, { signal: this.controller.signal });
      this.sync();
    }
    get sourceButton() { return this.info?.querySelector(`#ProductSubmitButton-${CSS.escape(this.sectionId)}`); }
    sync() {
      const source = this.sourceButton;
      if (!source) { this.hidden = true; this.visibility(); return; }
      if (source !== this.observedButton) {
        this.intersection?.disconnect(); this.observedButton = source;
        this.intersection = new IntersectionObserver(entries => {
          this.hidden = entries[0].isIntersecting; this.visibility();
        }, { threshold: 0 });
        this.intersection.observe(source);
      }
      const button = this.querySelector('[data-purchase-submit]');
      const disabled = source.disabled || source.getAttribute('aria-disabled') === 'true';
      if (button.disabled !== disabled) button.disabled = disabled;
      const label = source.querySelector('span')?.textContent.trim() || source.textContent.trim();
      if (button.textContent !== label) button.textContent = label;
      const sourcePrice = this.info.querySelector(`#price-${CSS.escape(this.sectionId)}`);
      const targetPrice = this.querySelector('[data-purchase-price]');
      // Clone only the price component, without IDs or live-region attributes.
      const price = sourcePrice?.querySelector('.price');
      if (price && targetPrice.dataset.source !== price.outerHTML) {
        const clone = price.cloneNode(true);
        [clone,...clone.querySelectorAll('[id], [role], [aria-live]')].forEach(node => {
          node.removeAttribute('id'); node.removeAttribute('role'); node.removeAttribute('aria-live');
        });
        targetPrice.replaceChildren(clone); targetPrice.dataset.source = price.outerHTML;
      }
      const options = Array.from(this.info.querySelectorAll('variant-selects input:checked, variant-selects select')).map(input => input.value).join(' / ');
      const targetOptions = this.querySelector('[data-purchase-options]');
      if (targetOptions.textContent !== options) targetOptions.textContent = options;
    }
    visibility() {
      const active = !this.hidden && (this.classList.contains('mp-purchase--all') || window.matchMedia('(max-width: 749px)').matches);
      document.body.classList.toggle('monela-has-sticky', active);
    }
    disconnectedCallback() {
      this.controller?.abort(); this.mutations?.disconnect(); this.intersection?.disconnect();
      document.body.classList.remove('monela-has-sticky');
    }
  });
})();
